import {PromotionsAttributes, PromotionsDisplayConfig, PromotionsReview, PromotionsSetup} from '@/containers'
import {Promotion, PromotionStep} from '@/types/promotion'
import {FC} from 'react'

type StepProps = {
  currentStep: PromotionStep
  finalResult: Promotion
  setCurrentStep: (step: PromotionStep) => void
}

export const Step: FC<StepProps> = ({currentStep, finalResult, setCurrentStep}) => {

  switch (currentStep) {
    case PromotionStep.SETUP:
      return <PromotionsSetup />
    case PromotionStep.DISPLAY:
      return <PromotionsDisplayConfig />
    case PromotionStep.ATTRIBUTES:
      return <PromotionsAttributes />
    case PromotionStep.REVIEW:
      return <PromotionsReview data={finalResult} setCurrentStep={setCurrentStep} />
    default:
      return null
  }
}
